/* eslint no-undef: 0 */
import React from 'react'
import { Helmet } from 'react-helmet'
import { MobxRouter } from 'mobx-router'
import { NotificationContainer } from 'react-notifications'
import { observer, Provider } from 'mobx-react'
import * as defaultConst from '../constants/default_constants'
import Menu from './menu'

export const App = observer(({ store }) => {
  const hostName = ['loca', 'dev.', 'stg.'].indexOf((window.location.hostname).substring(0, 4)) >= 0
  const siteName = Conf.siteName + ((hostName && ' ' + (window.location.hostname).substring(0, 3).toUpperCase()) || '')

  return (
    <section className={'view-wrapper container-fluid css-template-' + (store.userCss)}>
      <Helmet
        defaultTitle={siteName}
        titleTemplate={`%s${defaultConst.HTML_DIVIDER}${siteName}`} />
      <link
        rel='stylesheet'
        type='text/css'
        href={store.userCss && `/css/bootstrap.min.${store.userCss}.css`} />
      <div className='row' style={{ width: '100%' }}>
        <Menu store={store} />
        <div className='main'>
          <Provider store={store}>
            <MobxRouter />
          </Provider>
        </div>
      </div>
      <NotificationContainer enterTimeout={500} leaveTimeout={500} />
    </section>
  )
})
